import { render, staticRenderFns } from "./NeedDetail.vue?vue&type=template&id=7c3d598b&"
import script from "./NeedDetail.vue?vue&type=script&lang=js&"
export * from "./NeedDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "NeedDetail.vue"
export default component.exports